import { useState } from "react";
import { ReadWellLogo } from "../assets/images";
import { Wrapper } from "./styles/RegisterStyle";
import { Typography } from '@mui/material';
import { FormRow } from "../components";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import errorHandler from "../utils/errorHandler";
import { useNavigate } from "react-router-dom";
import AppLogo from "../components/AppLogo";
import { getCurrentUser, loginUser, registerUser } from "../controller/users/usersController";
import { logoutUser } from "../slices/auth/authenticationSlice";

const initalState = {
  name: "",
  email: "",
  password: "",
  confirmPassword:"",
  isRegistered: true,
};
const Register = (props) => {
  const [registerData, setRegisterData] = useState(initalState);
  const [passNotMatchError, setPassNotMatchError] = useState(false);
  const { credObj, isLoading } = useSelector(store => store.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onDataChanged = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === "confirmPassword") {
      let prevPassword = registerData.password;
      if (prevPassword !== value) {
        setPassNotMatchError(true);
      } else {
        setPassNotMatchError(false);
      }
    }
    setRegisterData({...registerData, [name]:value});
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    const { name , email, password, confirmPassword, isRegistered } = registerData;
    if (!email || !password || (!isRegistered && !confirmPassword) || (!isRegistered && !name)) {
        errorHandler("Please fill out the fields");
        return;
    }
    if (!isRegistered && (password !== confirmPassword)) {
      errorHandler("Password doesn't match!");
      return;
    }
    if (isRegistered) {
      try {
        // If user is switching accounts, clear any cached auth/user state first.
        if (credObj?.token) dispatch(logoutUser());

        await dispatch(loginUser({ email: email, password: password })).unwrap();
        const current = await dispatch(getCurrentUser()).unwrap();

        const isEmailVerified = current?.data?.isEmailVerified;
        const resolvedEmail = current?.data?.email || email;
        if (isEmailVerified === false) {
          navigate(
            `/verify-email?email=${encodeURIComponent(resolvedEmail)}&from=login`,
            { replace: true, state: { fromLogin: true } }
          );
          return;
        }

        navigate("/", { replace: true });
      } catch (err) {
        errorHandler(err);
      }
      return;
    }

    try {
      if (credObj?.token) dispatch(logoutUser());
      await dispatch(registerUser({ name, email, password, group: "adult" })).unwrap();
      navigate(`/verify-email?email=${encodeURIComponent(email)}&from=register`, {
        replace: true,
        state: { fromRegister: true },
      });
    } catch (err) {
      errorHandler(err);
    }
  };
  const toggleIsRegister = () => {
    setRegisterData({ ...registerData, isRegistered: !registerData.isRegistered})
  };
  return (
    <Wrapper className="full-page">
      <form className="form" onSubmit={onSubmit}>
        <AppLogo
            containerStyle="logo-container"
            textStyle="logo-text"
          />
        <h3>{registerData.isRegistered ? "Login" : "Register"}</h3>
        {!registerData.isRegistered && (
          <FormRow
            type="text"
            name="name"
            value={registerData.name}
            handleChange={onDataChanged}
          />
        )}
        <FormRow
          type="email"
          name="email"
          value={registerData.email}
          handleChange={onDataChanged}
        />
        <FormRow
          type="password"
          name="password"
          value={registerData.password}
          handleChange={onDataChanged}
        />
       {!registerData.isRegistered && (
         <FormRow
         type="password"
         name="confirmPassword"
         value={registerData.confirmPassword}
         handleChange={onDataChanged}
       />
       )}
       {!registerData.isRegistered && (
        <Typography color="error">{passNotMatchError ? "password doesn't match" :<></>}</Typography>
       )}
        <button className="btn btn-block" disabled={isLoading}>{isLoading ? "Loading...":"Submit"}</button>
        <p>
          {registerData.isRegistered ? "Not registered yet?": "Already a registered"}
          <button type="button" onClick={toggleIsRegister} className="member-btn">
            {registerData.isRegistered ? "Register" : "Login"}
          </button>
        </p>
      </form>
    </Wrapper>
  );
};

export default Register;
